import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaPlanoTrabalhoRecursoConcedidoInicio: [],
    buscaPlanoTrabalhoRecursoConcedidoSucesso: ['planoTrabalhoRecursoConcedido'],
    buscaPlanoTrabalhoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaPlanoTrabalhoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaPlanoTrabalhoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarPlanoTrabalho(filtro)
            .then(response => dispatch(Creators.buscaPlanoTrabalhoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaPlanoTrabalhoRecursoConcedidoErro(error)))
    }
}

const buscaPlanoTrabalhoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaPlanoTrabalhoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaPlanoTrabalhoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.planoTrabalhoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_CONCEDIDO_INICIO]: buscaPlanoTrabalhoRecursoConcedidoInicio,
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_CONCEDIDO_ERRO]: buscaPlanoTrabalhoRecursoConcedidoErro,
    [Types.BUSCA_PLANO_TRABALHO_RECURSO_CONCEDIDO_SUCESSO]: buscaPlanoTrabalhoRecursoConcedidoSucesso,
})
